const IPAPI_URL = "https://ipapi.co/json";

const normalizeCallingCode = (code) => String(code ?? "").replace(/^\+/, "");

const findAreaCodeInList = (areaCodeList, callingCode) => {
  const normalized = normalizeCallingCode(callingCode);
  if (!normalized) return undefined;
  return areaCodeList.find((a) => String(a.area_code) === normalized)?.area_code;
};

const getAreaCodeFromIpapi = async () => {
  const res = await fetch(IPAPI_URL);
  if (!res.ok) throw new Error("ipapi request failed");
  const data = await res.json();
  if (data.error) throw new Error(data.reason || "ipapi error");
  return normalizeCallingCode(data.country_calling_code?.split(",")[0]);
};

export const resolveDefaultAreaCode = async (areaCodeList) => {
  if (!areaCodeList?.length) return undefined;

  try {
    const ipapiCallingCode = await getAreaCodeFromIpapi();
    const matchedFromIpapi = findAreaCodeInList(areaCodeList, ipapiCallingCode);
    if (matchedFromIpapi) return matchedFromIpapi;
  } catch (err) {
    console.debug("resolveDefaultAreaCode ipapi fallback", err);
  }

  return areaCodeList[0]?.area_code;
};
